/* Pin the rotation pivot explicitly: WebKit anchors CSS rotation of an <svg>
   element at the top-left unless the reference box and origin are spelled
   out. Lives on the base class so the component's own spin and app-side
   rhythm classes (e.g. the boot screen's step spin) both pivot on center. */
.brand-spinner {
  transform-box: view-box;
  transform-origin: center;
}

.brand-spinner-outline {
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* Pulsed per-revolution rotation: one turn every 1.8s, always in the same
   direction, accelerating mid-turn and settling at each full rotation
   (easeInOutCubic). */
.brand-spinner-spin {
  animation: brand-spinner-spin 1.8s cubic-bezier(0.65, 0, 0.35, 1) infinite;
}

@keyframes brand-spinner-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .brand-spinner-spin {
    animation: none;
  }

  /* Hydrated spinners skip rendering the SMIL gradient rotation entirely;
     this solid brand stroke outranks the gradient stroke attribute so
     statically prerendered markup shows no motion before hydration either. */
  .brand-spinner-outline {
    stroke: var(--color-icon-brand-default);
  }
}
